
import { Component, Vue } from 'vue-property-decorator';
import { throttle } from 'lodash-es';

@Component({
  name: 'LivePage',
  components: {},
})
export default class LivePage extends Vue {
  calcFn() {
    const shadowEl = document.getElementById('shadow-container') as HTMLElement;
    const windowHeight = window.screen.height;
    let percent = window.scrollY / windowHeight;
    const threshold = 0.8
    if (percent >= threshold) {
      percent = threshold;
    }

    const percentStr = percent + '';

    if (percentStr !== shadowEl.style.opacity) {
      shadowEl.style.opacity = percent + '';
    }
  }
  mounted() {
    const shadowEl = document.getElementById('shadow-container');
    const myVideo: any = document.getElementById('bgvideo');
    myVideo.style.zIndex = -2
    if (shadowEl) {
      window.addEventListener('scroll', throttle(this.calcFn, 30));
      setTimeout(this.calcFn, 30);
    }
  }
}
